import React from "react";

function BackButton({ handleBack }) {
  return (
    <div className="col justify-content-center align-self-center">
      <button
        className="btn btn-outline-secondary my-2 row"
        onClick={handleBack}
      >
        ← Back
      </button>
    </div>
  );
}

export default BackButton;
